import { HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Download } from '../../../shared/services/api-helpers';
import { ApiService } from '../../../shared/services/api.service';
import { AuthTokenService } from './auth-token.service';

@Injectable({
  providedIn: 'root'
})
export class PpbApiService {

  constructor(private api: ApiService,
              private authTokenService: AuthTokenService
  ) { }

  getPublic<T>(
    path: string,
    params?: HttpParams,
    headers?: HttpHeaders
  ): Observable<T> {
    return this.api.get(path, params, headers)
  }

  get<T>(path: string,
         params?: HttpParams,
         headers: HttpHeaders = new HttpHeaders()
  ): Observable<T> {
    return this.api.get(path, params, this.addAuth(headers).append('resource', 'ALL'))
  }

  post<T>(
    path: string,
    payload: any = {},
    params: HttpParams = new HttpParams(),
    headers: HttpHeaders = new HttpHeaders()
  ): Observable<T> {
    return this.api.post<T>(path, payload, params, this.addAuth(headers));
  }

  postPublic<T>(
    path: string,
    payload: any = {},
    params: HttpParams = new HttpParams(),
    headers: HttpHeaders = new HttpHeaders()
  ): Observable<T> {
    return this.api.post<T>(path, payload, params, headers);
  }

  put<T>(
    path: string,
    payload: any = {},
    params: HttpParams = new HttpParams(),
    headers: HttpHeaders = new HttpHeaders()
  ): Observable<T> {
    return this.api.put<T>(path, payload, params, this.addAuth(headers))
  }

  delete<T>(
    path: string,
    params: HttpParams = new HttpParams(),
    headers: HttpHeaders = new HttpHeaders()
  ): Observable<T> {
    return this.api.delete<T>(path, params, this.addAuth(headers))
  }

  fileDownload(
    path: string,
    filename: string,
    params: HttpParams = new HttpParams(),
    newHeaders?: HttpHeaders
  ): Observable<Download> {
    return this.api.fileDownload(path, filename, params, newHeaders);
  }

  fileUpload(
    path: string,
    payload: any,
    params: HttpParams = new HttpParams(),
    newHeaders: HttpHeaders = new HttpHeaders(),
  ): Observable<HttpEvent<File>> {
    return this.api.fileUpload(path, payload, params, this.addAuth(newHeaders));
  }


  private addAuth(headers: HttpHeaders): HttpHeaders {
    if (this.authTokenService.checkAuth()) {
      headers = headers.append(
        'Authorization', this.authTokenService.getAccessToken())
    }

    return headers;
  }
}
